import {FC, useEffect} from 'react';
import {Tooltip} from 'react-tooltip';
import {observer} from 'mobx-react-lite';
import {Box, IconButton, useToken} from '@chakra-ui/react';
import {Svg, useKeyPress} from '@progress-fe/ui-kit';
import {useT} from '@progress-fe/core';

interface IProps {
  isActive: boolean;
  onToggle: () => void;
}

const TOOLTIP_ID = 'FIELD_PICKER_TOOLTIP_ID';

const InspectorIconButtonFC: FC<IProps> = ({isActive, onToggle}) => {
  const [borderHex] = useToken('colors', ['border']);

  const {isTildaPressed} = useKeyPress();
  const {t} = useT();

  useEffect(() => {
    if (isTildaPressed) {
      onToggle();
    }
  }, [isTildaPressed, onToggle]);

  return (
    <Box>
      <IconButton
        aria-label=""
        size="sm"
        variant={isActive ? 'ghostDark' : 'ghost'}
        data-tooltip-id={TOOLTIP_ID}
        icon={<Svg name="DevPicker" />}
        onClick={onToggle}
      />

      <Tooltip
        id={TOOLTIP_ID}
        delayShow={250}
        border={`1px solid ${borderHex}`}
        closeEvents={{click: true, mouseleave: true}}
        style={{padding: '0', backgroundColor: 'white'}}
        opacity="1"
      >
        <Box color="bodyText" p="6px 10px" fontSize="12px">
          {t(`labels.turn${isActive ? 'Off' : 'On'}Inspector`)}
        </Box>
      </Tooltip>
    </Box>
  );
};

export const InspectorIconButton = observer(InspectorIconButtonFC);
